/**
 * Created by Administrador on 17/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('subClassifications', {
                parent: 'app',
                url: '/subClassifications?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/adminClassification/subClassification/subClassifications.html',
                        controller: 'subClassificationCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminClassifications('subClassifications')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['subClassification']);
                            }],
                            subClassifications: ['subClassificationService', '$stateParams', function (subClassificationService, $stateParams) {
                                return subClassificationService.getSubClassifications($stateParams.page, $stateParams.size);
                            }],
                            fareSubClassifications: ['fareSubClassificationService', function (fareSubClassificationService) {
                                return fareSubClassificationService.getFareSubClassificationList();
                            }]
                        }
                    }
                }
            })
            .state('subClassificationNew', {
                parent: 'app',
                url: '/subClassification/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/adminClassification/subClassification/newSubClassification.html',
                        controller: 'newEditSubClassificationCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminClassifications('subClassifications')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['subClassification']);
                            }],
                            action: [function() {
                                return "new";
                            }],
                            subClassification: [function() {
                                return null;
                            }],
                            classifications: ['classificationService', function (classificationService) {
                                return classificationService.getClassificationList();
                            }],
                            fareSubClassifications: [function() {
                                return null;
                            }],
                        }
                    }
                }
            })
            .state('subClassificationEdit', {
                parent: 'app',
                url: '/subClassification/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/adminClassification/subClassification/editSubClassification.html',
                        controller: 'newEditSubClassificationCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminClassifications('subClassifications')
                            }],
                            subClassification: ['subClassificationService', '$stateParams', function (subClassificationService, $stateParams) {
                             return subClassificationService.getSubClassification($stateParams.id,true)
                             }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['subClassification']);
                            }],
                            action: [function() {
                                return "edit";
                            }],
                            classifications: ['classificationService', function (classificationService) {
                                return classificationService.getClassificationList();
                            }],
                            fareSubClassifications: ['fareSubClassificationService','$stateParams', function (fareSubClassificationService,$stateParams) {
                                return fareSubClassificationService.getFareSubClasBySubClassId($stateParams.id);
                            }]
                        }
                    }
                }
            })
            .state('subClassificationDelete', {
                parent: 'subClassifications',
                url: '/subClassification/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configCargo/adminClassification/subClassification/deleteSubClassification.html',
                        controller: 'deleteSubClassificationCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            subClassification: ['subClassificationService', '$stateParams', function (subClassificationService) {
                                return subClassificationService.getSubClassification($stateParams.id,false)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['subClassification']);
                            }]
                        }
                    }).result.then(function () {
                        $state.go('subClassifications', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
